import React, {useMemo, useState} from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { BlockForm } from './BlockForm';
import environment from '../../lib/RelayUtils';
import * as BlockEditMutation from '../../mutations/BlockEditMutation';
import {createFragmentContainer, graphql} from "react-relay";
import {blockToFormData, formDataToParams} from "./utils";
import RaisedButton from "material-ui/RaisedButton";
import * as BlockDeleteMutation from "../../mutations/BlockDeleteMutation";

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

const BlockEdit = (props) => {
	const {history, viewer} = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);

	const initialValues = useMemo(() => {
		return blockToFormData(viewer.block)
	}, [viewer])

	const onSubmit = data => {
		const finalData = formDataToParams(data, {
			id: viewer.block.id,
		})
		BlockEditMutation.commit(environment, finalData, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Пользователь успешно создан');
				history.push('/blocks')
			}
		})
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	const handleDelete = () => {
		if (confirm('Вы действитель хотите удалить релкамный блок')) {
			BlockDeleteMutation.commit(environment, {
				id: viewer.block.id,
			}, (error: ?Error) => {
				if (!error) {
					history.push('/blocks')
				}
			})
		}
	};

	if (!viewer.block) {
		return <Paper style={{ width: '100%', padding: 16 }}>
			Передан неверный идентификатор
		</Paper>
	}

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<BlockForm initialValues={initialValues} viewer={props.viewer} isCreation={true} onSubmit={onSubmit}>
				<RaisedButton
					style={{
						marginLeft: 20,
					}}
					labelColor={'#ffffff'}
					onClick={handleDelete}
					backgroundColor={'#f50000'}
					label={'Удалить'}
				/>
			</BlockForm>
			{snackbarMessage && <Snackbar
				open={true}
				bodyStyle={bodyStyle}
				message={snackbarMessage}
				onRequestClose={handleCloseSnackbar}
			/>}
		</Paper>
	);
};

export default withRouter(
	createFragmentContainer(
		BlockEdit,
		graphql`
			fragment BlockEdit_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }) {
				...ArticleSelector_viewer
				id
				block(id: $id) {
					id
					title
					active
					slug
					linkedArticles {
						article {
							id
							title
						}
						title
					}
				}
			}
		`,
	),
);


// WEBPACK FOOTER //
// src/components/blocks/BlockEdit.js